export const GET_DMX_UNIVERSES_BY_CONTROLLER = 'GET_DMX_UNIVERSES_BY_CONTROLLER';
export const GET_DMX_UNIVERSES_BY_CONTROLLER_SUCCESS = 'GET_DMX_UNIVERSES_BY_CONTROLLER_SUCCESS';
export const GET_DMX_UNIVERSES_BY_CONTROLLER_ERROR = 'GET_DMX_UNIVERSES_BY_CONTROLLER_ERROR';
